module.exports = __webpack_public_path__ + "static/media/update_notification.e6db4d2b.png";